export const CAMPAIGN_ORGANIZERS_METADATA_REQUESTED = 'campaignOrganizers/METADATA_REQUESTED';
export const CAMPAIGN_ORGANIZERS_METADATA_SUCCESS = 'campaignOrganizers/METADATA_SUCCESS';
export const CAMPAIGN_ORGANIZERS_METADATA_FAILURE = 'campaignOrganizers/METADATA_FAILURE';

export const CAMPAIGN_ORGANIZERS_LIST_DATA_REQUESTED = 'campaignOrganizers/LIST_REQUESTED';
export const CAMPAIGN_ORGANIZERS_LIST_DATA_SUCCESS = 'campaignOrganizers/LIST_SUCCESS';
export const CAMPAIGN_ORGANIZERS_LIST_DATA_FAILURE = 'campaignOrganizers/LIST_FAILURE';

export const CAMPAIGN_ORGANIZERS_CREATE_REQUESTED = 'campaignOrganizers/CREATE_REQUESTED';
export const CAMPAIGN_ORGANIZERS_CREATE_SUCCESS = 'campaignOrganizers/CREATE_SUCCESS';
export const CAMPAIGN_ORGANIZERS_CREATE_FAILURE = 'campaignOrganizers/CREATE_FAILURE';

export const CAMPAIGN_ORGANIZERS_UPDATE_REQUESTED = 'campaignOrganizers/UPDATE_REQUESTED';
export const CAMPAIGN_ORGANIZERS_UPDATE_SUCCESS = 'campaignOrganizers/UPDATE_SUCCESS';
export const CAMPAIGN_ORGANIZERS_UPDATE_FAILURE = 'campaignOrganizers/UPDATE_FAILURE';

export const CAMPAIGN_ORGANIZERS_GET_REQUESTED = 'campaignOrganizers/GET_REQUESTED';
export const CAMPAIGN_ORGANIZERS_GET_SUCCESS = 'campaignOrganizers/GET_SUCCESS';
export const CAMPAIGN_ORGANIZERS_GET_FAILURE = 'campaignOrganizers/GET_FAILURE';

export const CAMPAIGN_ORGANIZERS_DELETE_REQUESTED = 'campaignOrganizers/DELETE_REQUESTED';
export const CAMPAIGN_ORGANIZERS_DELETE_SUCCESS = 'campaignOrganizers/DELETE_SUCCESS';
export const CAMPAIGN_ORGANIZERS_DELETE_FAILURE = 'campaignOrganizers/DELETE_FAILURE';

export const CAMPAIGN_ORGANIZERS_MESSAGE_CLEAR = 'campaignOrganizers/MESSAGE_CLEAR';
